import { useState } from 'react'
import styled from 'styled-components'
import { Autocomplete, TextField } from '@mui/material'

const StyledSearch = styled(Autocomplete)`
  border: 0;
  min-width: 550px;
  width: 100%;
  outline: none;
`

const AutoCompleteSearch = ({ options, onSelect }) => {
  const [value, setValue] = useState(null)
  const [inputValue, setInputValue] = useState('')

  return (
    <StyledSearch
      id='user-search-list'
      value={value}
      onChange={(_, newValue) => {
        onSelect({ id: newValue.id, name: newValue.name })
        setValue(newValue)
      }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue)
      }}
      getOptionLabel={option => option.name}
      options={options}
      renderInput={params => (
        <>
          <TextField
            placeholder='Selecione colaboradores(ras)'
            {...params}
          />
        </>
      )}
    />
  )
}

export default AutoCompleteSearch
